import { AccountPage } from '../../../../../ui/features/accounts/components/AccountPage/AccountPage';
import React from 'react';
import { Route, Routes } from 'react-router';
import { GroupsList } from './components';
import { GroupSectionPage } from './components/GroupSectionPage';
export const GroupsPanel = (props) => {
    return (React.createElement(Routes, null,
        React.createElement(Route, { path: '', element: React.createElement(GroupsList, { hideHeader: props.hideHeader, slideoutMenuItems: props.slideoutMenuItems }) }),
        React.createElement(Route, { path: ':groupId/:sectionNameLowerCase', element: React.createElement(GroupSectionPage, { customMemberSlideoutMenuItems: props.customMemberSlideoutMenuItems, customMemberDetailsComponent: props.customMemberDetailsComponent }) }),
        React.createElement(Route, { path: ':groupId/:sectionNameLowerCase/:accountId', element: React.createElement(AccountPage, { customAccountProfileHeaderComponent: props.customAccountProfileHeaderComponent }) })));
};
